import { ValidationResultModel } from 'app/shared/models/validation-results/validation-result.model';

export class VehicleOwnershipSoldNoticeModel {
    public id: number;
    public vehicleOwnershipId: number;
    public jurisdictionId: number;
    public buyersName: string;
    public addressLine1: string;
    public addressLine2: string;
    public city: string;
    public postalZipCode: string;
    public dateOfSale: Date;
    public soldNoticeReceivedDate: Date;

    // Gets or sets the validationResult model
    public validationResults: ValidationResultModel[];
}
